import React from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
  index: number;
  rating: number;
  size?: 'sm' | 'md' | 'lg';
}

export const StarRating: React.FC<StarRatingProps> = ({ index, rating, size = 'md' }) => {
  const sizeClass = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <Star
      className={`${sizeClass[size]} ${
        index < Math.floor(rating)
          ? 'text-yellow-400 fill-yellow-400'
          : index < rating && index > Math.floor(rating) - 0.1
          ? 'text-yellow-400 fill-yellow-400 opacity-50'
          : 'text-gray-300'
      }`}
    />
  );
}; 